import React, { memo } from "react";
import cx from "classnames";
import Switch from "@ui/Switch";
import t from "../../../../../../../../../i18n";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";
import { useBlockOptionUpdateCallback } from "../hook/useOptionUpdateCallback";

export const YAxisGroupByUnitToggle = memo(({ className }: { className?: string }) => {
  const { block } = useGUIEditorContext();
  const updateBlockOption = useBlockOptionUpdateCallback();

  return (
    <Switch
      checked={block?.config.options?.groupYAxesByUnit ?? false}
      onChange={e => updateBlockOption("groupYAxesByUnit", e.target.checked)}
      className={cx(className)}
      tooltipOverlay={t("tooltip.editor.plot.group_axis_by_unit")}
    >
      {t("project.dashboard.editor.gui.section.group_by_unit.title")}
    </Switch>
  );
});
